import { Switch } from '@thanx/uikit/switch'
import { useStyletron } from '@thanx/uikit/theme'
import type { PaginationT } from 'models/Pagination'
import { forwardRef } from 'react'
import Spinner from '../../Spinner'
import CustomControls from './CustomControls'

import type { Option } from 'baseui/select'

type CustomDropdownProps = {
  children: React.ReactNode
  isLoading: boolean
  value: Option[]
  pagination?: PaginationT
  onPageChange?: (page: number) => void
  selectAll: boolean
  onSelectAllChange: (selected: boolean) => void
}

const CustomDropdown = forwardRef<HTMLDivElement, CustomDropdownProps>(
  (
    {
      children,
      isLoading,
      value,
      pagination,
      onPageChange,
      selectAll,
      onSelectAllChange,
    },
    ref
  ) => {
    const [css, defaultTheme] = useStyletron()

    return (
      <div
        ref={ref}
        className={css({
          backgroundColor: defaultTheme.colors.white,
          borderTopLeftRadius: defaultTheme.borders.radius200,
          borderTopRightRadius: defaultTheme.borders.radius200,
          borderBottomLeftRadius: defaultTheme.borders.radius200,
          borderBottomRightRadius: defaultTheme.borders.radius200,
          fontSize: defaultTheme.sizing.scale550,
          maxHeight: '400px',
          overflowY: 'auto',
          padding: 0,
          margin: 0,
          position: 'relative',
        })}
      >
        <div
          className={css({
            position: 'sticky',
            top: 0,
            zIndex: 1,
            backgroundColor: defaultTheme.colors.white,
            borderBottom: `1px solid ${defaultTheme.colors.grey30}`,
          })}
        >
          <CustomControls
            value={value}
            isLoading={isLoading}
            pagination={pagination}
            onPageChange={onPageChange}
            selectAll={selectAll}
            onSelectAllChange={onSelectAllChange}
          />
        </div>
        <Switch condition={isLoading} fallback={children}>
          <div
            className={`d-flex align-items-center justify-content-center ${css({
              minHeight: '120px',
              width: '100%',
            })}`}
          >
            <Spinner isLoading size="48px" />
          </div>
        </Switch>
      </div>
    )
  }
)

CustomDropdown.displayName = 'CustomDropdown'

export default CustomDropdown
